import { FirebaseError } from "firebase/app";
import { useSnackbar } from "notistack";

export const useToast = () => {
  const { enqueueSnackbar } = useSnackbar();

  const showSuccess = (message: string) => {
    enqueueSnackbar(message, { variant: "success" });
  };

  const showError = (message: string) => {
    enqueueSnackbar(message, { variant: "error" });
  };

  const handleFirebaseError = (error: unknown) => {
    const err = error as FirebaseError;
    // @ts-ignore
    enqueueSnackbar(err.details ?? err.message, { variant: "error" });
  };

  return { handleFirebaseError, showSuccess, showError } as const;
};
